export const ASSET_NAME = 'about-page';

export const loadData = () => () => Promise.resolve();
